import * as React from 'react';

import { Autocomplete, Link, Spacer, Typography } from '@emburse/ui-core';

import { CardIssuingApiService } from '@ClientApi/cardIssuing';
import { IGenericOption } from '@Shared/constants';

interface IMerchantCategoryCodesFieldProps {
  defaultValue?: string[];
  onChange: (selectedIds: string[]) => void;
  multiple?: boolean;
  disabled?: boolean;
}

type MerchantCategoryOption = { label: string; value: string };

const MerchantCategoryCodesFieldHelperText = () => {
  return (
    <Typography variant="caption" style={{ paddingLeft: '12px' }}>
      Click{' '}
      <Link href={window.whitelabelConfiguration.supportLinks.merchantCategoryGroups} target="_blank" rel="noopener noreferrer">
        Here
      </Link>{' '}
      to learn more about Merchant Category Groups.{' '}
    </Typography>
  );
};

export const MerchantCategoryCodesField: React.FC<IMerchantCategoryCodesFieldProps> = ({
  defaultValue = [],
  onChange,
  multiple = true,
  disabled
}) => {
  const [options, setOptions] = React.useState<MerchantCategoryOption[]>([]);
  const [value, setValue] = React.useState<MerchantCategoryOption[]>([]);

  React.useEffect(() => {
    async function getMerchantCategoryCodes() {
      const codes = await CardIssuingApiService.getMerchantCategoryOptions();
      const codesWithLabels = codes.map((code) => ({ label: code.description!, value: code.groupCode! }));
      const sortedCodes = codesWithLabels.sort((a, b) => a.label.localeCompare(b.label));
      setOptions(sortedCodes);
      setValue(sortedCodes.filter((option) => defaultValue?.includes(option.value)));
    }

    getMerchantCategoryCodes();
  }, []);

  return (
    <>
      <Autocomplete
        label={'Allowed Merchant Category Groups'}
        multiple={multiple}
        showCheckbox
        limitTags={2}
        disableCloseOnSelect
        disabled={disabled}
        // AW-4720 / ANGULAR-B5MM : defaultValue can sometimes be `null` instead of undefined, which will not get
        // a value from a default param. Must use optional chaining to cover this case.
        value={value}
        options={options}
        getOptionLabel={(option: any) => option.label}
        onChange={(_: any, selectedOptions: IGenericOption[]) => {
          setValue(selectedOptions);
          onChange(selectedOptions?.map((option) => option.value));
        }}
      />
      <Spacer size={2} />
      <MerchantCategoryCodesFieldHelperText />
    </>
  );
};
